import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import { Typography } from '@leshen/gatsby-theme-leshen'

/**
 * @param {string} key
 * @param {string} state
 * @returns {{question: string, answer: string}}
 */
export function getStateFAQ(key, state) {
  const faq = {
    QA1: {
      question: `Does DISH Network have service in ${state}?`,
      answer: (
        <Typography variant="feature">
          Yes, DISH is available in all 50 states.
          <GatsbyLink to="/">Availability</GatsbyLink> may vary within states,
          though. Call us to find out if DISH Network is in your neighborhood.
        </Typography>
      ),
    },
    QA2: {
      question: `Is DISH TV available in ${state}?`,
      answer: (
        <Typography variant="feature">
          Yes, DISH TV is <GatsbyLink to="/">available</GatsbyLink> in your
          state. Depending on where you live, availability may vary. Contact us
          to see if your home location has DISH TV availability.
        </Typography>
      ),
    },
    QA3: {
      question: `Where can I find satellite TV packages available near me in ${state}?`,
      answer: (
        <Typography variant="feature">
          You can find satellite TV packages in your state by calling us or
          visiting our <GatsbyLink to="/">availability</GatsbyLink> page. Either
          way, you can have satellite TV and high-speed internet in your home in
          no time.
        </Typography>
      ),
    },
    QP1: {
      question: `How much do DISH TV packages cost in ${state}?`,
      answer: (
        <Typography variant="feature">
          Packages start at $84.99 a month* in your state. Call to see the cost
          of additional{' '}
          <GatsbyLink to="https://www.usdish.com/packages" target="_blank">
            packages
          </GatsbyLink>
          .
        </Typography>
      ),
    },
    QP2: {
      question: `How much are DISH satellite TV packages in ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH satellite TV{' '}
          <GatsbyLink to="https://www.usdish.com/packages" target="_blank">
            packages
          </GatsbyLink>{' '}
          start at $84.99 a month and may cost as much as $114.99 a month.* Call
          to see which package works best for your lifestyle.
        </Typography>
      ),
    },
    QP3: {
      question: `How much is DISH Network in ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH Network has multiple packages in your state. The America&#39;s
          Top 120 Package is $91.99 a month, while the America&#39;s Top 250
          Package is $109.99 a month.* Call to find out if these{' '}
          <GatsbyLink to="https://www.usdish.com/packages" target="_blank">
            packages
          </GatsbyLink>{' '}
          are available in your area.
        </Typography>
      ),
    },
    QC1: {
      question: `What is the contact number for DISH Network in ${state}?`,
      answer: (
        <Typography variant="feature">
          You can call DISH Network in your state at{' '}
          <a href={'tel:833-871-4465'}>833-871-4465</a>.
        </Typography>
      ),
    },
    QC2: {
      question: `How can I reach a DISH TV representative in ${state}?`,
      answer: (
        <Typography variant="feature">
          Call <a href={'tel:833-871-4465'}>833-871-4465</a> to reach a DISH TV
          representative in your state.
        </Typography>
      ),
    },
    QC3: {
      question: `How do I contact DISH TV in ${state}?`,
      answer: (
        <Typography variant="feature">
          Contact DISH TV in your state at{' '}
          <a href={'tel:833-871-4465'}>833-871-4465</a>.
        </Typography>
      ),
    },
    QB1: {
      question: `Does DISH satellite TV have internet bundles in ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH Satellite TV works with multiple internet providers, such as
          Hughesnet and Frontier, to provide high-quality internet across the
          country. Find out if these internet providers server your area by
          calling us today.
        </Typography>
      ),
    },
    QB2: {
      question: `Am I able to bundle internet with DISH TV in ${state}?`,
      answer: (
        <Typography variant="feature">
          Yes, you can{' '}
          <GatsbyLink to="https://www.usdish.com/bundles">
            bundle internet with DISH TV
          </GatsbyLink>{' '}
          in your state as long as the internet providers DISH works with are
          available in your area. DISH works with HughesNet Satellite Internet
          and Frontier to provide access to high-speed internet. today.
        </Typography>
      ),
    },
    QB3: {
      question: `Can I combine internet services with DISH TV in ${state}?`,
      answer: (
        <Typography variant="feature">
          Absolutely! You have the option to{' '}
          <GatsbyLink to="https://www.usdish.com/bundles">
            bundle internet services with DISH TV
          </GatsbyLink>{' '}
          in your state, subject to availability from the internet providers
          that DISH partners with. These providers typically include HughesNet
          Satellite Internet and Frontier, offering high-speed internet access
          in many areas. today!
        </Typography>
      ),
    },
    QD1: {
      question: `Does DISH TV offer any satellite and internet deals in ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH TV is always looking for ways to help you save and enjoy your
          entertainment. Subscribe to the DISH newsletter to stay in the loop on
          all the latest deals.
        </Typography>
      ),
    },
    QD2: {
      question: `What deals does DISH Network offer in ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH Network offers a 2-year TV price guarantee, a reliable signal
          guarantee, and the DISH ANYWHERE App, which allows you to stream your
          favorite shows and recordings from a mobile device. Watching live and
          recorded TV anywhere requires an internet-connected Hopper w/Sling or
          Hopper 3 and compatible mobile device.
        </Typography>
      ),
    },
    QD3: {
      question: `What deals are available for DISH in ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH guarantees a 2-year TV price1 so you’re not surprised by rate
          hikes for 24 months. They also guarantee signal reliability or your
          money back.
        </Typography>
      ),
    },
  }
  return faq[key]
}

/**
 * @param {string} key
 * @param {string} state
 * @returns {{question: string, answer: string}}
 */
export function getStateFAQSchema(key, state) {
  const schemaFAQ = {
    QA1: {
      question: `Does DISH Network have service in ${state}?`,
      answer:
        'Yes, DISH is available in all 50 states. <a href=\'/availability\'>Availability</a> may vary within states, though. Call us to find out if DISH Network is in your neighborhood.',
    },
    QA2: {
      question: `Is DISH TV available in ${state}?`,
      answer:
        'Yes, DISH TV is available in your state. Depending on where you live, availability may vary. Contact us to see if your home location has DISH TV <a href=\'/availability\'>availability</a>.',
    },
    QA3: {
      question: `Where can I find satellite TV packages available near me in ${state}?`,
      answer:
        'You can find satellite TV packages in your state by calling us or visiting our <a href=\'/availability\'>availability</a> page. Either way, you can have satellite TV and high-speed internet in our home in no time.',
    },
    QP1: {
      question: `How much do DISH TV packages cost in ${state}?`,
      answer:
        'Packages start at $84.99 a month* in your state. Call to see the cost of additional <a href=\'https://www.usdish.com/packages\'>packages</a>.',
    },
    QP2: {
      question: `How much are DISH satellite TV package in ${state}?`,
      answer:
        'DISH satellite TV packages start at $84.99 a month and may cost as much as $114.99 a month.* Call to see which <a href=\'https://www.usdish.com/packages\'>package</a> works best for your lifestyle.',
    },
    QP3: {
      question: `How much is DISH Network in ${state}?`,
      answer:
        'DISH Network has multiple packages in your state. The America\'s Top 120 Package is $84.99 a month, while the America\'s Top 250 Package is $109.99 a month.* Call to find out if these <a href=\'https://www.usdish.com/packages\'>packages</a> are available in your area.',
    },
    QC1: {
      question: `What is the contact number for DISH Network in ${state}?`,
      answer:
        'You can call DISH Network in your state at <a href=\'tel:833-871-4465}\'>833-871-4465</a>.',
    },
    QC2: {
      question: `How can I reach a DISH TV representative in ${state}?`,
      answer:
        'Call <a href=\'tel:833-871-4465\'>833-871-4465</a> to reach a DISH TV representative in your state.',
    },
    QC3: {
      question: `How do I contact Dish TV in ${state}?`,
      answer:
        'Contact DISH TV in your state at <a href=\'tel:833-871-4465\'>833-871-4465</a>.',
    },
    QB1: {
      question: `Does DISH satellite TV have internet bundles in ${state}?`,
      answer:
        'DISH Satellite TV works with multiple internet providers, such as HughesNet and Frontier, to provide high-quality internet across the country. Find out if these internet providers serve your area by calling us today.',
    },
    QB2: {
      question: `Am I able to bundle internet with DISH TV in ${state}?`,
      answer:
        'Yes, you can bundle internet with DISH TV in your state as long as the internet providers DISH works with are available in your area. DISH works with HughesNet Satellite Internet and Frontier to provide access to high-speed internet.',
    },
    QB3: {
      question: `Am I able to bundle internet with DISH TV in ${state}?`,
      answer:
        'Absolutely! You have the option to bundle internet services with DISH TV in your state, subject to availability from the internet providers that DISH partners with. These providers typically include HughesNet Satellite Internet and Frontier, offering high-speed internet access in many areas.',
    },
    QD1: {
      question: `Does DISH TV offer any satellite and internet deals in ${state}?`,
      answer:
        'DISH TV is always looking for ways to help you save and enjoy your entertainment. Subscribe to the DISH newsletter to stay in the loop on all the latest deals.',
    },
    QD2: {
      question: `What deals does DISH Network offer in ${state}?`,
      answer:
        'DISH Network offers a 2-year TV price guarantee, a reliable signal guarantee, and the DISH ANYWHERE App, which allows you to stream your favorite shows and recordings from a mobile device. Watching live and recorded TV anywhere requires and internet-connected Hopper w/Sling or Hopper 3 and compatible mobile device.',
    },
    QD3: {
      question: `What deals are available for DISH in ${state}?`,
      answer:
        'DISH guarantees a 2-year TV price1 so you’re not surprised by rate hikes for 24 months. They also guarantee signal reliability or your money back.',
    },
  }
  return schemaFAQ?.[key]
}
